import { app } from '../../../app';
import { Controller } from './public-user-accounts.controller';

app.component('userPublicUserAccounts', {
    bindings: {
        account: '<',
        passwordManagers: '<',
        authenticators: '<',
        publicUserAccounts: '<',
        publicServicesWithSso$: '<',
        publicServicesWithSsoAnd2FA$: '<',
    },
    controller: Controller,
    templateUrl: require('./public-user-accounts.html'),
});


// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/public-user-accounts.component.js